/* eslint-disable max-len */
/* eslint-disable no-restricted-globals */
import { dwmRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];

class DwmInsuranceCards {

    constructor($scope, $http, $rootScope, Util, dwmValidations) {

        $scope.insuranceAccountNameIsValid = true;
        $scope.insuranceAccountNumberIsValid = true;

        const validations = dwmValidations;

        const onDwmDataNext = () => {

            const assets = dwmRepository.getAll('assets') || {};

            if (assets.primaryMember) {

                $scope.insuranceCards = assets.primaryMember.monitoredAccounts.insuranceCards;
                $scope.insuranceCards.entries.forEach((entry) => {

                    entry.showUpdateInput = false;

                });

            }

        };

        const dwmRepositoryObservable = dwmRepository.getObservable();
        dwmRepositoryObservable
            .subscribe(
                data => onDwmDataNext(data),
                () => { },
                () => { },
            );

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.showRemoveEntryScreen = false;
        $scope.showUpdateButton = false;

        $scope.addNewEntry = () => {

            $scope.newEntryVisible = true;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = true;
            setTimeout(() => {

                angular.element('.update-insurance-account-name').trigger('focus');

            }, 100);

        };

        $scope.cancelNewEntry = () => {

            $scope.insuranceAccountNameIsValid = true;
            $scope.insuranceAccountNumberIsValid = true;
            $scope.newEntryVisible = false;
            $scope.showAddNewButton = true;
            $scope.showSaveButton = false;
            $scope.newInsuranceAccountName = '';
            $scope.newInsuranceAccountNumber = '';
            $scope.newEntrySubmitted = false;

        };

        $scope.updateEntry = (index) => {

            $scope.newEntryVisible = false;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = false;
            $scope.showUpdateButton = true;

            $scope.insuranceCards.entries.forEach((entry, loopIndex) => {

                if (index === loopIndex) {

                    entry.showUpdateInput = true;
                    $scope.updateEntryPayload = entry;

                    // Save initial entry values to use in case of update is canceled
                    $scope.initialInsuranceAccountName = entry.providerName;
                    $scope.initialInsuranceAccountNumber = entry.policyNumber;
                    $scope.initialEntryIndex = loopIndex;

                } else {

                    entry.showUpdateInput = false;

                }

            });

            setTimeout(() => {

                angular.element('.update-insurance-account-name').trigger('focus');

            }, 100);

        };

        $scope.cancelUpdateNewEntry = () => {

            $scope.insuranceAccountNameIsValid = true;
            $scope.insuranceAccountNumberIsValid = true;
            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;

            $scope.insuranceCards.entries.forEach((entry) => {

                entry.showUpdateInput = false;

            });

            $scope.updateEntryPayload = {};

            // Revert changes of the selected entry
            $scope.insuranceCards.entries[$scope.initialEntryIndex].providerName =
                $scope.initialInsuranceAccountName;
            $scope.insuranceCards.entries[$scope.initialEntryIndex].policyNumber =
                $scope.initialInsuranceAccountNumber;

        };

        $scope.validateInsuranceAccountName = ($event) => {

            if ($scope.newEntrySubmitted) {

                $scope.insuranceAccountNameIsValid = $event.currentTarget.value &&
                    validations.insuranceNameValidator($event.currentTarget.value.trim());

            }

            $scope.newInsuranceAccountName = $event.currentTarget.value;

        };

        $scope.validateInsuranceAccountNumber = ($event) => {

            if ($scope.newEntrySubmitted) {

                $scope.insuranceAccountNumberIsValid = $event.currentTarget.value && validations.insuranceNumberValidator($event.currentTarget.value.trim());

            }

            $scope.newInsuranceAccountNumber = $event.currentTarget.value;

        };

        $scope.saveNewEntry = () => {

            $scope.insuranceAccountNameIsValid = $scope.newInsuranceAccountName === undefined ? false : validations.insuranceNameValidator($scope.newInsuranceAccountName.trim());
            $scope.insuranceAccountNumberIsValid = $scope.newInsuranceAccountNumber === undefined ? false : validations.insuranceNumberValidator($scope.newInsuranceAccountNumber.trim());

            $scope.newEntrySubmitted = true;

            if ($scope.insuranceAccountNameIsValid && $scope.insuranceAccountNumberIsValid) {

                $scope.saveNewInsuranceCardIsLoading = true;

                const payload = {
                    insuranceCards: {
                        providerName: $scope.newInsuranceAccountName,
                        policyNumber: $scope.newInsuranceAccountNumber,
                        type: 'OTHER',
                    },
                };
                $http({
                    method: 'POST',
                    url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },
                    data: payload,

                }).then(() => {

                    $scope.newInsuranceAccountName = '';
                    $scope.newInsuranceAccountNumber = '';
                    $scope.saveNewInsuranceCardIsLoading = false;

                    $http({
                        method: 'GET',
                        url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            access_token: $rootScope.dwmNortonToken,
                            'Content-Type': 'application/json',
                        },

                    }).then((membersResponse) => {

                        dwmRepository.replace('assets', membersResponse.data);

                        const { monitoredAccounts, dwmCardStatus } = membersResponse.data.primaryMember;
                        Mixpanel.setCommonProperty('AIA Asset Insurance', monitoredAccounts.insuranceCards.entries.length);

                        Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                            Action: 'Add',
                            Entry: 'Insurance cards',
                        });

                        if (dwmCardStatus === 'add-more-data') {

                            $rootScope.showDwmCardHomepage = true;
                            $rootScope.showDwmAddMoreDataCard = true;

                        } else {

                            $rootScope.showDwmCardHomepage = false;

                        }

                        $scope.cancelNewEntry();

                    });

                }).catch((responseError) => {

                    $scope.saveNewInsuranceCardIsLoading = false;

                    if (responseError.data) {

                        if (responseError.data.errorCode === 4013) {

                            Alert.error('cw.dwm.dupliacte_entry_error');

                        } else {

                            Alert.error(
                                { message: 'cw.recommendation.error.connection_failed' },
                                {
                                    message: {
                                        brandname: CWCONFIG.partnerConfig.name,
                                        url: '/dashboard/support/tabs/support',
                                    },
                                },
                            );

                        }

                    }

                });


            }

        };

        $scope.removeEntry = (index) => {

            $scope.showRemoveEntryScreen = true;
            $scope.cancelNewEntry();

            $scope.removeEntryPayload = {
                insuranceCards:
                {
                    id: $scope.insuranceCards.entries[index].id,
                },
            };

        };

        $scope.confirmRemoveEntry = () => {

            $scope.confirmRemoveIsLoading = true;

            $http({
                method: 'DELETE',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount?payload=${encodeURIComponent(JSON.stringify($scope.removeEntryPayload))}`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
            }).then(() => {

                $scope.newInsuranceAccountName = '';
                $scope.newInsuranceAccountNumber = '';

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);

                    const { monitoredAccounts, dwmCardStatus } = membersResponse.data.primaryMember;
                    Mixpanel.setCommonProperty('AIA Asset Insurance', monitoredAccounts.insuranceCards.entries.length);

                    Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Delete',
                        Entry: 'Insurance cards',
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;

                    } else {

                        $rootScope.showDwmCardHomepage = false;

                    }

                    $scope.confirmRemoveIsLoading = false;
                    $scope.cancelRemoveEntry();
                    $scope.cancelUpdateNewEntry();

                });

            }).catch((responseError) => {

                $scope.confirmRemoveIsLoading = false;

                if (responseError.data) {

                    Alert.error(
                        { message: 'cw.recommendation.error.connection_failed' },
                        {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support',
                            },
                        },
                    );

                }

            });

        };

        $scope.cancelRemoveEntry = () => {

            $scope.showRemoveEntryScreen = false;
            $scope.removeEntryPayload = {};

        };

        $scope.updateInsuranceAccountName = ($event) => {

            $scope.insuranceAccountNameIsValid = $event.currentTarget.value &&
                validations.insuranceNameValidator($event.currentTarget.value.trim());

            if ($scope.insuranceAccountNameIsValid) {

                $scope.updateEntryPayload.providerName = $event.currentTarget.value;

            }

        };

        $scope.updateInsuranceAccountNumber = ($event) => {

            $scope.insuranceAccountNumberIsValid = $event.currentTarget.value && validations.insuranceNumberValidator($event.currentTarget.value.trim());

            if ($scope.insuranceAccountNumberIsValid) {

                $scope.updateEntryPayload.policyNumber = $event.currentTarget.value;

            }

        };

        $scope.saveUpdatedEntry = () => {

            $scope.saveUpdatedEntryIsLoading = true;

            $http({
                method: 'PUT',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
                data: { insuranceCards: $scope.updateEntryPayload },
            }).then(() => {

                Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Update',
                    Entry: 'Insurance cards',
                });

                $scope.showAddNewButton = true;
                $scope.showUpdateButton = false;
                $scope.updateEntryPayload = {};
                $scope.saveUpdatedEntryIsLoading = false;

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);
                    $scope.confirmRemoveIsLoading = false;

                });

            }).catch((responseError) => {

                $scope.saveUpdatedEntryIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        Alert.error('cw.dwm.dupliacte_entry_error');

                    } else {

                        Alert.error(
                            { message: 'cw.recommendation.error.connection_failed' },
                            {
                                message: {
                                    brandname: CWCONFIG.partnerConfig.name,
                                    url: '/dashboard/support/tabs/support',
                                },
                            },
                        );

                    }

                }

            });

        };

    }

}

_serviceDependencies.push(DwmInsuranceCards);

angular.module('controllers')
    .controller('DwmInsuranceCards', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/dwm/insurance-cards/insurance-cards.js